export default __webpack_public_path__ + "static/Motorboat-7b742703955c9b805f3905c5cfd0aa8d.png";